// SGEW 17 Oct: the shared button look (index.css .sgew-btn - rounded, Poppins 14px semibold, 38px). A caller names the
// colour in customClasses (sgew-btn-primary / -cancel / -danger / ...); without one it is sgew-btn-outline (outline) or
// primary. A caller still passing its own bg- colour keeps it (no colour class is put under it).
const OWN_COLOUR = /(^|\s)(sgew-btn-(primary|success|danger|cancel|neutral|outline)|!?bg-)/;

export default function IconBtn({
  text,
  onclick,
  children,
  disabled,
  outline = false,
  customClasses = "",
  type = "button",
}) {
  return (
    <button
      disabled={disabled}
      onClick={onclick}
      className={`sgew-btn ${
        OWN_COLOUR.test(customClasses) ? "" : outline ? "sgew-btn-outline" : "sgew-btn-primary"
      } ${customClasses}`}
      type={type}
    >
      {children ? (
        <>
          <span>{text}</span>
          {children}
        </>
      ) : (
        text
      )}
    </button>
  );
}
